//
// Software Name: Orange Design System Charts
// SPDX-FileCopyrightText: Copyright (c) 2023 - 2026 Orange SA
// SPDX-License-Identifier: MIT
//
// This software is distributed under the MIT license.
//
export const DEFAULT_COLORS = {
    color: [
        'var(--ods-default-1, #085edb)',
        'var(--ods-default-2, #0a6e31)',
        'var(--ods-default-3, #bc4d9a)',
        'var(--ods-default-4, #492191)',
        'var(--ods-default-5, #b98f11)',
        'var(--ods-default-6, #666666)',
        'var(--ods-default-7, #3e9dd6)',
        'var(--ods-default-8, #27a971)',
        'var(--ods-default-9, #d573bb)',
        'var(--ods-default-10, #9373bd)',
        'var(--ods-default-11, #9d6e06)',
        'var(--ods-default-12, #333333)',
    ],
};
